export const ENUM_STORAGES_LIST = "ENUM_STORAGES_LIST"
export const ENUM_STORAGES_LIST_SUCCESS = "ENUM_STORAGES_LIST_SUCCESS"
export const ENUM_STORAGES_LIST_ERROR = "ENUM_STORAGES_LIST_ERROR"
